export interface AuthPartner {
  loginType: AuthPartnerLoginType;
  partnerId: string;
  permissionComponent: string;
}

export type AuthPartnerLoginType = 'PFZ' | 'HEMPFARM' | 'AGRIPAK' | 'AGRITECHTEAM' | 'BURY' | 'AGROMA' | 'COMPLEXOR';

export const AUTH_PARTNERS: AuthPartner[] = [
  {
    partnerId: '523587b2-6586-4f5e-8987-399ac381550a',
    loginType: 'PFZ',
    permissionComponent: 'Organization.Partners.PFZ'
  },
  {
    partnerId: 'c32ef00b-4085-4e29-bd3a-3f9a51c40d1e',
    loginType: 'HEMPFARM',
    permissionComponent: 'Organization.Partners.HEMPFARM'
  },
  {
    partnerId: '6a6f2c6c-27a2-42c5-9217-89671a99b58f',
    loginType: 'AGRIPAK',
    permissionComponent: 'Organization.Partners.AGRIPAK'
  },
  {
    partnerId: '0514d91f-b2c3-493e-b1ad-ec9cb7568263',
    loginType: 'AGRITECHTEAM',
    permissionComponent: 'Organization.Partners.AGRITECHTEAM'
  },
  {
    partnerId: 'ff8c7bb9-081a-4361-97fb-d7c451d17124',
    loginType: 'BURY',
    permissionComponent: 'Organization.Partners.BURY'
  },
  {
    partnerId: 'daf27fd1-d77a-425d-ad67-82e643a33feb',
    loginType: 'AGROMA',
    permissionComponent: 'Organization.Partners.AGROMA'
  },
  {
    partnerId: '285c6c26-ca5c-4c0a-95d0-c58b2781f098',
    loginType: 'COMPLEXOR',
    permissionComponent: 'Organization.Partners.COMPLEXOR'
  }
];
